export default __webpack_public_path__ + "473448dc94abeeacde430ee49b45a511.png";